/**
 * VF Loyalty points redeem Replacer Model
 */

define(function(require, exports, module) {
    'use strict';

    var _ = require('underscore');
    var virtueFusionService = require('modules/services/vf.service');
    var BaseModel = require('common/base.model');

    module.exports = BaseModel.extend({

        sync: function(method, model, options) {
            if (method === 'read') {
                if (this.request && this.request.state() === 'pending') {
                    this.request
                        .done(options.success)
                        .fail(options.error);
                } else {
                    this.request = virtueFusionService
                        .getLoyaltyInfo()
                        .done(options.success)
                        .fail(options.error);
                }
            }
        },

        parse: function(response) {
            response.data.minRedeemValues = this.getMinRedeemValues(response.data);
            response.data.conversionRates = this.getConversionRates(response.data);

            return response;
        },

        redeemPoints: function(balanceToUpdate) {
            return virtueFusionService.redeemLoyaltyPoints(balanceToUpdate);
        },

        getCategory: function(data, balanceType) {
            return _.findWhere(
                data
                    .scheme
                    .redemptionBalances
                    .balances,
                {balanceType: balanceType}
            ).balanceCategory;
        },

        getMinRedeemValue: function(data, balanceType) {
            var minBalance = _.findWhere(
                data.scheme.redemptionBalances.minBalances, {category: this.getCategory(data, balanceType)}
            );

            return minBalance && minBalance.value ? minBalance.value : 0;
        },

        getMinRedeemValues: function(data) {
            return data.scheme.redemptionBalances.balances.reduce(function(map, balance) {
                map[balance.balanceType] = this.getMinRedeemValue(data, balance.balanceType);
                return map;
            }.bind(this), {});
        },

        getConversionRates: function(data) {
            return data.scheme.redemptionBalances.balances.reduce(function(map, balance) {
                map[balance.balanceType] = balance.conversionRate;
                return map;
            }, {});
        },

        getConversionRate: function(balanceType) {
            return _.findWhere(
                this.get('data').scheme.redemptionBalances.balances,
                {balanceType: balanceType}
            ).conversionRate;
        }
    });
});
